/**
 * Hamburger Menu Toggle
 * 
 * Handles the animation and interaction for the hamburger menu:
 * - Toggles hamburger button between lines and cross
 * - Shows/hides fullscreen menu overlay
 * - Prevents body scroll when menu is open
 * - Full keyboard navigation and focus management
 * - Focus trap when menu is open
 */

document.addEventListener('DOMContentLoaded', function () {
  const hamburgerButton = document.querySelector('.hamburger-button');
  const menuOverlay = document.querySelector('.menu-overlay');
  const body = document.body;
  const header = document.querySelector('.site-header');

  if (!hamburgerButton || !menuOverlay) {
    return;
  }

  // Get all focusable elements in the menu
  function getFocusableElements() {
    return menuOverlay.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  // Toggle menu function
  function toggleMenu(focusFirstLink = true) {
    const isActive = hamburgerButton.classList.contains('is-active');

    if (isActive) {
      // Close menu
      hamburgerButton.classList.remove('is-active');
      menuOverlay.classList.remove('is-active');
      body.classList.remove('menu-open');
      hamburgerButton.setAttribute('aria-expanded', 'false');
      menuOverlay.setAttribute('aria-hidden', 'true');

      // Return focus to hamburger button
      hamburgerButton.focus();
    } else {
      // Open menu
      hamburgerButton.classList.add('is-active');
      menuOverlay.classList.add('is-active');
      body.classList.add('menu-open');
      hamburgerButton.setAttribute('aria-expanded', 'true');
      menuOverlay.setAttribute('aria-hidden', 'false');

      // Focus first menu link after animation
      if (focusFirstLink) {
        setTimeout(() => {
          const focusableElements = getFocusableElements();
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          }
        }, 0);
      }
    }
  }

  // Focus trap - keep focus within menu when open
  function handleFocusTrap(e) {
    if (!hamburgerButton.classList.contains('is-active')) {
      return;
    }

    const focusableElements = Array.from(getFocusableElements());
    const allFocusable = [hamburgerButton, ...focusableElements];
    const firstFocusable = allFocusable[0];
    const lastFocusable = allFocusable[allFocusable.length - 1];

    // If shift+tab on first element, go to last
    if (e.key === 'Tab' && e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    }
    // If tab on last element, go to first
    else if (e.key === 'Tab' && !e.shiftKey) {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  // Click event on hamburger button
  hamburgerButton.addEventListener('click', () => toggleMenu(true));

  // Space/Enter key on hamburger button
  hamburgerButton.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      toggleMenu(true);
    }
  });

  // Handle keyboard events
  document.addEventListener('keydown', function (e) {
    // Close menu on escape key
    if (e.key === 'Escape' && hamburgerButton.classList.contains('is-active')) {
      toggleMenu(false);
    }

    // Focus trap
    handleFocusTrap(e);
  });

  // Close menu when clicking on a menu link
  const menuLinks = menuOverlay.querySelectorAll('.menu-overlay__nav a');
  menuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = link.getAttribute('href');
      const currentPage = window.location.pathname.replace(/\/$/, '');
      const linkUrl = document.createElement('a');
      linkUrl.href = href;
      const linkPage = linkUrl.pathname.replace(/\/$/, '');

      console.log(currentPage);
      console.log(linkPage);

      if (currentPage == linkPage) {
        toggleMenu(false);
      }
    });
  });

  // Prevent body from being tabbable when menu is closed
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        const isOpen = body.classList.contains('menu-open');

        // Get all focusable elements outside the menu
        const mainContent = document.querySelectorAll('main a, main button, main input, main select, main textarea, main [tabindex]');
        const headerContent = header ? header.querySelectorAll('a:not(.hamburger-button), button:not(.hamburger-button), input, select, textarea') : [];

        mainContent.forEach(el => {
          if (isOpen) {
            el.setAttribute('tabindex', '-1');
            el.dataset.originalTabindex = el.getAttribute('tabindex');
          } else {
            if (el.dataset.originalTabindex) {
              el.setAttribute('tabindex', el.dataset.originalTabindex);
              delete el.dataset.originalTabindex;
            } else {
              el.removeAttribute('tabindex');
            }
          }
        });

        headerContent.forEach(el => {
          if (isOpen) {
            el.setAttribute('tabindex', '-1');
          } else {
            el.removeAttribute('tabindex');
          }
        });
      }
    });
  });

  observer.observe(body, { attributes: true, attributeFilter: ['class'] });
});
